module.exports = __webpack_public_path__ + "static/media/16_plantilla_cuadrada_combo_simple_cp_gaseosas_vidrio_350_ccsa.096b258e.png";